import '../../icon/index.js';
import {customElement, property} from 'lit/decorators.js';
import styles from './style.scss';
import {html} from 'lit';
import {repeat} from 'lit/directives/repeat.js';
import {FlywheelComponent} from '#lit/lib/component.js';

export const ERROR_MODAL_ELEMENT_TAG = 'bulk-action-errors-modal';

/**
 * Modal for displaying bulk action errors
 */
@customElement(ERROR_MODAL_ELEMENT_TAG)
export default class BulkActionErrorsModal extends FlywheelComponent {
  static get styles() {
    return [styles];
  }

  @property({type: Boolean})
  open = false;

  @property({type: Array})
  results: string[] = [];

  @property({type: Array})
  errors: string[] = [];

  render() {
    const label = this.results.length > 0 ? 'Warning' : 'Errors';

    return html`<fly-modal
      label=${label}
      actions
      ?disableSecondaryAction=${true}
      ?preventCloseOnPrimaryAction=${false}
      .okLabel=${'Close'}
      .open=${this.open}
      @closed=${(e: Event) => {
        this.dispatchEvent(new CustomEvent('closed', {detail: e}));
      }}
      @cancel=${(e: Event) => {
        this.dispatchEvent(new CustomEvent('cancel', {detail: e}));
      }}
      @ok=${(e: Event) => {
        this.dispatchEvent(new CustomEvent('ok', {detail: e}));
      }}
    >
      ${repeat(
        this.results,
        result => result,
        result =>
          html`<div class="bulk-action bulk-action__ok">
            <fly-icon icon="check_circle" size="xs" fill="green"></fly-icon>
            ${result}
          </div>`
      )}
      ${repeat(
        this.errors,
        error => error,
        error =>
          html`<div class="bulk-action bulk-action__error">
            <fly-icon icon="warning" size="xs" fill="red"></fly-icon>
            ${error}
          </div>`
      )}
    </fly-modal>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [ERROR_MODAL_ELEMENT_TAG]: BulkActionErrorsModal;
  }
}
